export default {
  PIPELINE: "6a5f04ac-4720-11e9-bd01-0242ac140002",
  DEAD: "6a5f04dc-4720-11e9-bd01-0242ac140002",
  CLOSED: "6a5f04ec-4720-11e9-bd01-0242ac140002",
  REFINANCE: "6a5f04f9-4720-11e9-bd01-0242ac140002",
  SOLD: "6a5f0507-4720-11e9-bd01-0242ac140002",
  MODIFYING: "5c00eb29-b4cd-471c-b820-47773d09fa94",
  ADDING_SUPPLEMENTAL: "f9bf13d0-e918-4fe8-9227-d0304c9f2a8b"
};

export const dealStatusList = [
  { value: "6a5f04ac-4720-11e9-bd01-0242ac140002", name: "Pipeline" },
  { value: "6a5f04dc-4720-11e9-bd01-0242ac140002", name: "Dead" },
  { value: "6a5f04ec-4720-11e9-bd01-0242ac140002", name: "Closed" },
  { value: "6a5f04f9-4720-11e9-bd01-0242ac140002", name: "Refinance" },
  { value: "6a5f0507-4720-11e9-bd01-0242ac140002", name: "Sold" },
  { value: "5c00eb29-b4cd-471c-b820-47773d09fa94", name: "Modifying" },
  { value: "f9bf13d0-e918-4fe8-9227-d0304c9f2a8b", name: "Adding Supplemental" }
];
